import FormValidation from "../../Validation/FormValidation";

const Tel = {
    pattern: /^\+?[0-9]{2}[0-9]*\/?[0-9]{4}[0-9]*$/i,

    bind(form) {
        this.input = 'input[type="tel"]';
        form.find(this.input).on('keyup change paste', (evt) => {
            FormValidation.setValid($(evt.currentTarget), this.isValid($(evt.currentTarget)));
        });
    },

    check(form) {
        let ok = true;
        form.find(this.input).each((i, el) => {
            ok = this.isValid($(el));
            FormValidation.setValid($(el), ok, true);
        })
        return ok;
    },

    isValid(input) {
        const isRequired = input.closest('.input').is('.required');
        const isFilled = input.val().length > 0;

        if (isRequired || isFilled) return !!input.val().toString().match(this.pattern);
        else return true;
    },
}
export default Tel;
